import { render } from "./CoBrandNoir.vue?vue&type=template&id=69deeda8&scoped=true"
import script from "./CoBrandNoir.vue?vue&type=script&lang=js"
export * from "./CoBrandNoir.vue?vue&type=script&lang=js"

import "./CoBrandNoir.vue?vue&type=style&index=0&id=69deeda8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69deeda8"]])

export default __exports__